export default __webpack_public_path__ + "static/media/refNo-handwritten.0b9c4e0b.jpg";